import React from "react";
import "./pageLayout.scss";

function FooterBar() {
  return <footer className="footer-container">© SLB</footer>;
}

export default FooterBar;
